import React, { useEffect, useState, useRef, useCallback } from "react";
import "./V730iParameterGraph.scss";
import { Line } from "react-chartjs-2";
import moment, { duration } from 'moment';
import { getV730iPatientHistoryGraphData, getV730iPatientHistoryCursorData } from "../../../helper/patient-history-helper";
import { ACTIVE_PARAMETERS } from '../../../common/ENUMS/PARAMETER_ENUM';
import { ventilatorPatientHistoryCurrentCursorTime, ventilatorPatientHistoryCursorData, ventilatorPatientHistoryGraphApiData } from "../../../modules/actions/action";
import { connect } from "react-redux";
import Draggable from "react-draggable";

// --- Chart.js imports ---
import {
    Chart,
    LineElement,
    PointElement,
    LineController,
    CategoryScale,
    LinearScale,
    TimeScale,
    Tooltip,
    Legend,
} from "chart.js";

// --- IMPORTANT: register time adapter ---
import "chartjs-adapter-moment";
import { use } from "react";

// --- register Chart.js components ---
Chart.register(
    LineElement,
    PointElement,
    LineController,
    CategoryScale,
    LinearScale,
    TimeScale,
    Tooltip,
    Legend
);

const BATCH_SIZE = 5;
function V730iParameterGraph(props) {
    const [graphValues, setGraphValues] = useState({});
    const [batchIndex, setBatchIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const bottomRef = useRef(null);
    const pos = useRef({ x: 0, y: 0 });
    const timeRef = useRef(null);
    const [cursorData, setCursorData] = useState({});
    const sliderRef = useRef(null);
    const [cursorPos, setCursorPos] = useState({});
    const draggableRef = useRef(null);
    const graphRefs = useRef({});
    const cursorLineRef = useRef(null);
    const graphTitleRefs = useRef({});
    const [bounds, setBounds] = useState({});
    const lastDragTimeRefCursorLine = useRef(0)
    const draggableRefCursorLine = useRef(0)

    // const [disableCursor, setDisableCursor] = useState(false)


    // Load next 5 parameters
    const loadNextBatch = async (isReset = false) => {
        if (loading) return;
        // setDisableCursor(true)
        setLoading(true);

        const start = isReset ? 0 : batchIndex * BATCH_SIZE;
        const end = start + BATCH_SIZE;


        const batchIds = props?.selectedParamList?.slice(start, end) || [];
        if (batchIds.length === 0) {
            setHasMore(false);
            setLoading(false);
            return;
        }

        // console.log("batchIds in loadNextBatch--->", batchIds)

        // console.log("props.PatientHistoryTimeData in loadNextBatch--->", props.PatientHistoryTimeData)
        // console.log("props.PatientHistoryGraphData in loadNextBatch--->", props.PatientHistoryGraphData)

        //Check in cache 

        //Check the PatientHistoryTimeData has data or not
        if (props?.PatientHistoryTimeData && Object.keys(props?.PatientHistoryTimeData).length > 0) {
            //Check whether PatientHistoryGraphData has data or not 
            if (props?.PatientHistoryGraphData && Object.keys(props?.PatientHistoryGraphData).length > 0 && !(props.PatientHistoryGraphData?.isLoading)) {
                // console.log("PatientHistoryGraphData avaliable in cache")
                //Checks which ids data are avaliable in cache
                let cacheGraphAPIData = props.PatientHistoryGraphData?.data
                const keys = Object.keys(cacheGraphAPIData);
                const presentIdsData = {};
                const missingFromCache = [];

                batchIds.forEach(id => {
                    if (keys.includes(String(id))) {
                        presentIdsData[String(id)] = cacheGraphAPIData[String(id)]
                    } else {
                        missingFromCache.push(id);
                    }
                });

                // console.log("presentIdsData", presentIdsData)
                //Set the data for ids avaliable in cache
                if (Object.keys(presentIdsData).length > 0) {
                    setGraphValues(prev => ({
                        ...prev,
                        ...presentIdsData
                    }));
                }
                // console.log("missingFromCache", missingFromCache)
                //Call API fro missing Id's
                if (missingFromCache.length > 0) {
                    try {
                        // console.log("Calling getV730iPatientHistoryGraphData for missing Ids")

                        props.ventilatorPatientHistoryGraphApiData({
                            bedId: props.bedId,
                            isLoading: true,
                            data: cacheGraphAPIData
                        }) //Dispatch isLoading true

                        const apiObj = {
                            bedId: props.bedId,
                            startDateTime: props.PatientHistoryTimeData?.startDateTime,
                            endDateTime: props.PatientHistoryTimeData?.endDateTime,
                            selectedParamList: missingFromCache
                        };
                        const res = await getV730iPatientHistoryGraphData(apiObj);

                        // res.values = { paramId: [ {x,y}, ... ] }
                        setGraphValues(prev => ({
                            ...prev,
                            ...res.values
                        }));

                        props.ventilatorPatientHistoryGraphApiData({
                            bedId: props.bedId,
                            isLoading: false,
                            data: {
                                ...cacheGraphAPIData,
                                ...res.values
                            }
                        }) //Dispatch isLoading false + new-Data

                    } catch (err) {
                        console.log("Error in getV730iPatientHistoryGraphData api :", err);
                    }
                }
            } else {
                //Get Data of the desired ids through api ......
                try {
                    // console.log("PatientHistoryGraphData not avaliable in cache,.....Calling getV730iPatientHistoryGraphData for desired Ids")

                    props.ventilatorPatientHistoryGraphApiData({
                        bedId: props.bedId,
                        isLoading: true,
                        data: {}
                    })

                    const apiObj = {
                        bedId: props.bedId,
                        startDateTime: props.PatientHistoryTimeData?.startDateTime,
                        endDateTime: props.PatientHistoryTimeData?.endDateTime,
                        selectedParamList: batchIds
                    };
                    const res = await getV730iPatientHistoryGraphData(apiObj);

                    // res.values = { paramId: [ {x,y}, ... ] }
                    setGraphValues(prev => ({
                        ...prev,
                        ...res.values
                    }));

                    props.ventilatorPatientHistoryGraphApiData({
                        bedId: props.bedId,
                        isLoading: false,
                        data: {
                            ...res.values
                        }
                    }) //Dispatch isLoading false + new-Data

                } catch (err) {
                    console.log("Error in getV730iPatientHistoryGraphData api :", err);
                }
            }

            // console.log("batch-index updated")
            setBatchIndex(prev => prev + 1);
            if (batchIds.length < BATCH_SIZE) {
                setHasMore(false); // last batch
            }
        }
        else {
            console.log("PatientHistoryTimeData not avaliable in loadNextBatch")
        }

        setLoading(false);
    };

    // RESET when props change
    useEffect(() => {
        if (!props.selectedParamList || !props.PatientHistoryTimeData || !(Object.keys(props.PatientHistoryTimeData).length > 0)) return;

        setGraphValues({});
        setBatchIndex(0);
        setHasMore(true);
        // console.log("hit loadbatch from main useffect")
        // graphRefs.current = {};

        // RESET SCROLL POSITION ⇦ THIS IS THE FIX
        const container = document.querySelector(".patient-history-lines");
        if (container) {
            // console.log("reseting scroll position--0")
            container.scrollTop = 0;
        }

        loadNextBatch(true);
    }, [props.selectedParamList, props.PatientHistoryTimeData]);

    // Intersection Observer for infinite scroll
    useEffect(() => {
        const container = document.querySelector(".patient-history-lines");
        if (!container) return;

        const handleScroll = () => {
            const { scrollTop, clientHeight, scrollHeight } = container;

            const isNearBottom = scrollHeight - scrollTop - clientHeight < 150;
            // 150px buffer before bottom

            if (isNearBottom && hasMore && !loading) {
                // console.log("hit loadbatch from scroll");
                loadNextBatch();
            }
        };

        container.addEventListener("scroll", handleScroll);
        // Cleanup on unmount OR when dependencies change
        return () => {
            // console.log("scroll reset due to dependency change");
            container.removeEventListener("scroll", handleScroll);
        };

    }, [hasMore, loading, props.PatientHistoryTimeData, props.selectedParamList, props.PatientHistoryGraphData, batchIndex]);


    const calculateNewBounds = () => {
        const keys = Object.keys(graphRefs.current);
        if (keys.length === 0) {
            return null;
        }

        let chart = null;
        for (const k of keys) {
            if (graphRefs.current[k]) {
                chart = graphRefs.current[k];
                break;
            }
        }
        if (!chart) {
            // console.log("No chart instance found");
            return null
        };

        const canvas = chart.canvas;
        if (!canvas) {
            // console.log("No canvas found in chart");
            return null
        };

        // chart.chartArea gives the actual plotting area
        const chartArea = chart.chartArea;
        if (!chartArea) return null; // might not be ready yet

        const graphRect = canvas.getBoundingClientRect();
        const parentRect = canvas.parentElement.getBoundingClientRect();

        const left = graphRect.left - parentRect.left + chartArea.left;
        const width = chartArea.right - chartArea.left;
        const right = left + width;

        return { left, right, width };
    }

    const updateGraphTitlesFromCursorData = (timestamp) => {

        if (!timestamp || !cursorData || Object.keys(cursorData).length === 0) return;

        // console.log("graphRef.current", graphRefs.current)
        let ans = timestamp
        Object.keys(graphRefs.current).forEach(paramId => {
            // console.log("hi3");
            const el = graphTitleRefs.current?.[paramId];
            if (!el) return;

            const value = cursorData?.[ans]?.[paramId];
            const paramTitle = ACTIVE_PARAMETERS[paramId]?.TITLE || paramId;

            el.textContent = `${paramTitle} : ${value ?? '--'}`;
        });

    };

    const updateGraphTitlesFromRawData = (timestamp) => {
        if (!timestamp || !graphValues || Object.keys(graphValues).length === 0) return;
        // console.log("timestamp in updateGraphTitlesFromRawData", timestamp)
        const targetTime = new Date(timestamp).getTime();

        Object.keys(graphRefs.current).forEach(paramId => {
            // console.log("hi");
            const el = graphTitleRefs.current[paramId];
            if (!el) return;
            // console.log("hi 2")
            const dataArr = graphValues[paramId];
            // console.log("dataArr", dataArr)
            if (!dataArr || dataArr.length === 0) {
                el.textContent = `${ACTIVE_PARAMETERS[paramId]?.TITLE || paramId} : --`;
                return;
            }

            // --- BINARY SEARCH ---
            let left = 0;
            let right = dataArr.length - 1;
            let idx = -1;

            while (left <= right) {
                const mid = (left + right) >> 1;
                const midTime = new Date(dataArr[mid].x).getTime();

                if (midTime <= targetTime) {
                    idx = mid;            // possible candidate
                    left = mid + 1;       // look for closer (later) value
                } else {
                    right = mid - 1;
                }
            }

            // no point <= timestamp
            if (idx === -1) {
                // console.log("no point <= timestamp")
                el.textContent = `${ACTIVE_PARAMETERS[paramId]?.TITLE || paramId} : --`;
                return;
            }

            // check diff <= 2 seconds
            const pkt = dataArr[idx];
            const diff = targetTime - new Date(pkt.x).getTime();
            // console.log("pkt", pkt)
            if (diff <= 2000) {
                el.textContent = `${ACTIVE_PARAMETERS[paramId]?.TITLE || paramId} : ${pkt.y ?? '--'}`;
            } else {
                el.textContent = `${ACTIVE_PARAMETERS[paramId]?.TITLE || paramId} : --`;
            }
        });
    };

    const getCurrentXTime = (x, startDateTime, endDateTime, useRaw) => {

        const newBounds = calculateNewBounds();
        if (!newBounds) return null;
        const { left, right, width } = newBounds;
        if (!startDateTime || !endDateTime) return null;
        x = x - left;

        let currentXTime = null
        if (useRaw) {
            currentXTime = moment.utc(startDateTime).add(((endDateTime - startDateTime) * x) / width, "ms").toISOString();
        } else {
            if (!cursorData || Object.keys(cursorData).length === 0) return null
            // console.log("cursorData", cursorData)
            const keys = Object.keys(cursorData);  // already sorted as you said
            // console.log("keys", keys)
            const bucketCount = keys.length - 1;
            const bucketWidth = width / bucketCount;
            // nearest bucket index
            let index = Math.round(x / bucketWidth);
            // clamp index
            index = Math.max(0, Math.min(index, keys.length - 1));
            currentXTime = keys[index];
            // console.log("currentXTime--->", currentXTime)
        }
        return currentXTime;
    };

    const updateCursor = (x) => {
        pos.current.x = x; // store, no re-render

        // document.querySelector(".cursor-line").style.left = `${x}px`;
        if (cursorLineRef.current) {
            cursorLineRef.current.style.transform = `translate(${x}px, 0px)`;
        }

        if (draggableRefCursorLine.current) {
            // console.log("Resetting draggable internal position");
            draggableRefCursorLine.current.setState({ x: x, y: 0 });
        }


        // Move slider WITHOUT RE-RENDER
        if (sliderRef.current) {
            sliderRef.current.style.transform = `translate(${x}px, 0px)`;
        }

        if (draggableRef.current) {
            // console.log("Resetting draggable internal position");
            draggableRef.current.setState({ x: x, y: 0 });
        }

        //Find excatly X-time value at this distance
        let startDateTime = props?.PatientHistoryTimeData?.startDateTime ? new Date(props.PatientHistoryTimeData.startDateTime) : null
        let endDateTime = props?.PatientHistoryTimeData?.endDateTime ? new Date(props.PatientHistoryTimeData.endDateTime) : null
        if (!startDateTime || !endDateTime) return;
        const diffMs = endDateTime - startDateTime;
        const diffSeconds = diffMs / 1000;
        const diffMinutes = diffSeconds / 60;

        let useRaw;
        if (diffMinutes > 15) {
            useRaw = false;
        } else {
            useRaw = true;
        }
        // console.log("hiii")
        const nearestTime = getCurrentXTime(x, startDateTime, endDateTime, useRaw);
        if (!nearestTime) return
        if (timeRef.current) {
            timeRef.current.textContent = nearestTime
                ? moment.utc(nearestTime).utcOffset(330).format("HH:mm:ss")
                : "HH:mm:ss";
            timeRef.current.utcTime = nearestTime;
        }

        if (useRaw) {
            // console.log("Using raw graph data for updating graph titles");
            updateGraphTitlesFromRawData(nearestTime);
        } else {
            // console.log("Using cursor data for updating graph titles");
            updateGraphTitlesFromCursorData(nearestTime);
        }

        // Update Redux store with current cursor time
        props.ventilatorPatientHistoryCurrentCursorTime({
            bedId: props.bedId,
            currentCursorTime: nearestTime,
        });
    };

    const updateGraphBounds = () => {

        const newBounds = calculateNewBounds();
        if (!newBounds) return;

        const { left, right, width } = newBounds;

        // only update if changed
        setBounds(prev => {
            if (prev.left !== left || prev.right !== right) {
                // console.log("Graph bounds updated:", { left, right });
                return { left, right };
            }
            return prev;
        });
    };

    const waitForBounds = () => {
        return new Promise(resolve => {
            const check = () => {
                const b = calculateNewBounds();
                if (b) return resolve(b);
                requestAnimationFrame(check); // keep checking until ready
            };
            check();
        });
    };

    useEffect(() => {
        // console.log("cursorData updated useEffect");
        (async () => {
            const b = await waitForBounds();
            updateCursor(b.left);

            // RESET DRAGGABLE INTERNAL POSITION WITHOUT RERENDER
            // if (draggableRef.current) {
            //     // console.log("Resetting draggable internal position");
            //     draggableRef.current.setState({ x: b.left, y: 0 });
            // }
        })();

    }, [cursorData]);

    const loadCursorData = async () => {

        if (props.PatientHistoryTimeData && Object.keys(props.PatientHistoryTimeData).length > 0) {
            // console.log("PatientHistoryTimeData avaliable", props.PatientHistoryTimeData)

            if (props.PatientHistoryCursorData && Object.keys(props.PatientHistoryCursorData).length > 0 && !(props.PatientHistoryCursorData?.isLoading)) {
                // console.log("PatientHistoryCursorData avaliable in cache")
                //Set the cursor data from cache
                let cacheCursorData = props.PatientHistoryCursorData?.cursorData
                setCursorData(cacheCursorData);
            }
            else {
                //Call API to get cursor data
                try {
                    // console.log("PatientHistoryCursorData not avaliable in cache,.....Calling getV730iPatientHistoryCursorData API")
                    //Set isLoading true for cursor data
                    const apiObj = {
                        bedId: props.bedId,
                        startDateTime: props.PatientHistoryTimeData?.startDateTime,
                        endDateTime: props.PatientHistoryTimeData?.endDateTime,
                    };

                    // console.log("apiObj", apiObj)
                    const diffMs = new Date(apiObj.endDateTime) - new Date(apiObj.startDateTime);
                    const diffSeconds = diffMs / 1000;
                    const diffMinutes = diffSeconds / 60;
                    // console.log("Diff in mins in loadCursorData", diffMinutes)
                    //If duration <=5 min then no need to call cursor data api , as we use raw data for updating graph titles
                    if (diffMinutes > 15) {

                        props.ventilatorPatientHistoryCursorData({
                            bedId: props.bedId,
                            isLoading: true,
                            cursorData: {}
                        })
                        const res = await getV730iPatientHistoryCursorData(apiObj);
                        setCursorData(res.data);

                        props.ventilatorPatientHistoryCursorData({
                            bedId: props.bedId,
                            isLoading: false,
                            cursorData: res.data,
                        }) //Dispatch isLoading false + new-Data

                    }
                    else {
                        setCursorData({})
                        props.ventilatorPatientHistoryCursorData({
                            bedId: props.bedId,
                            isLoading: false,
                            cursorData: {},
                        }) //Dispatch isLoading false + empty data
                    }

                } catch (err) {
                    console.log("Error in getV730iPatientHistoryGraphData api :", err);
                }
            }

        } else {
            console.log("PatientHistoryTimeData not avaliable in cursor")
        }
    }

    useEffect(() => {
        if (!props.PatientHistoryTimeData || !(Object.keys(props.PatientHistoryTimeData).length > 0)) return;
        // setCursorData({});
        loadCursorData();
    }, [props.PatientHistoryTimeData]);

    useEffect(() => {
        if (!graphValues || Object.keys(graphValues).length === 0) return;
        if (!timeRef.current || !timeRef.current.utcTime) return;
        // console.log("timeRef.current.textContent in graphValues useEffect", timeRef.current.textContent)
        let startDateTime = props?.PatientHistoryTimeData?.startDateTime ? new Date(props.PatientHistoryTimeData.startDateTime) : null
        let endDateTime = props?.PatientHistoryTimeData?.endDateTime ? new Date(props.PatientHistoryTimeData.endDateTime) : null
        if (!startDateTime || !endDateTime) return;

        const diffMs = endDateTime - startDateTime;
        const diffSeconds = diffMs / 1000;
        const diffMinutes = diffSeconds / 60;

        if (diffMinutes > 15) {
            // console.log("Using cursor data for updating graph titles in graphValues useEffect");
            updateGraphTitlesFromCursorData(timeRef.current.utcTime);
        } else {
            // console.log("Using raw graph data for updating graph titles in graphValues useEffect");
            updateGraphTitlesFromRawData(timeRef.current.utcTime);
        }
    }, [graphValues]);

    // const graphKeys = Object.keys(graphValues);
    const graphKeys = props.selectedParamList?.length
        ? props.selectedParamList.filter((id) => id in graphValues)
        : Object.keys(graphValues);
    const lastDragTimeRef = useRef(0);





    return (
        <>
            <div className="patient-history-graphs">
                {/* <div className="cursor-line" ref={cursorLineRef}></div> */}

                <Draggable
                    axis="x"
                    bounds={bounds}
                    nodeRef={cursorLineRef}
                    // disabled = {!cursorLineRef.current}
                    onDrag={(e, data) => {
                        const now = Date.now();

                        if (cursorLineRef.current) {
                            cursorLineRef.current.style.transform = `translate(${data.x}px, 0px)`;
                        }


                        if (sliderRef.current) {
                            sliderRef.current.style.transform = `translate(${data.x}px, 0px)`;
                        }
                        if (draggableRef.current) {
                            // console.log("Resetting draggable internal position");
                            draggableRef.current.setState({ x: data.x, y: 0 });
                        }


                        if (now - lastDragTimeRefCursorLine.current >= 500) {
                            lastDragTimeRefCursorLine.current = now;
                            updateCursor(data.x);   // throttled updates
                        }
                    }}
                    onStop={(e, data) => {
                        updateCursor(data.x);       // FINAL accurate value
                    }}
                    ref={draggableRefCursorLine}
                >
                    <div className="cursor-line" ref={(el) => { cursorLineRef.current = el }} />

                </Draggable>
                <div className="patient-history-cursor">
                    <Draggable
                        axis="x"
                        bounds={bounds}
                        nodeRef={sliderRef}
                        // disabled = {!cursorLineRef.current}
                        onDrag={(e, data) => {
                            const now = Date.now();

                            if (sliderRef.current) {
                                sliderRef.current.style.transform = `translate(${data.x}px, 0px)`;
                            }


                            if (cursorLineRef.current) {
                                cursorLineRef.current.style.transform = `translate(${data.x}px, 0px)`;
                            }
                            if (draggableRefCursorLine.current) {
                                // console.log("Resetting draggable internal position");
                                draggableRefCursorLine.current.setState({ x: data.x, y: 0 });
                            }
                            if (now - lastDragTimeRef.current >= 500) {
                                lastDragTimeRef.current = now;
                                updateCursor(data.x);   // throttled updates
                            }
                        }}
                        onStop={(e, data) => {
                            updateCursor(data.x);       // FINAL accurate value
                        }}
                        ref={draggableRef}
                    >
                        <div className="purple-slider" ref={(el) => { sliderRef.current = el; timeRef.current = el; }} />
                    </Draggable>
                </div>
                <div className="patient-history-lines">
                    {graphKeys.map(paramId => {
                        const paramInfo = ACTIVE_PARAMETERS[paramId];
                        if (!paramInfo) return null;
                        const paramTitle = paramInfo.TITLE;
                        const paramData = graphValues[paramId] || [];
                        // console.log(paramTitle)
                        // console.log("paramData--->", paramData)
                        const validYValues = paramData
                            .map(p => p.y)
                            .filter(y => typeof y === "number");

                        const maxY = validYValues.length ? Math.max(...validYValues) : 0;
                        // console.log("maxY", maxY)
                        // add padding (10% or minimum 1)
                        const padding = Math.max(maxY * 0.1, 1);
                        const yAxisMax = maxY + padding;
                        // console.log("yAxisMax", yAxisMax)
                        // divide into 5 parts
                        const stepSize = yAxisMax / 4;

                        return (
                            <div className="graph-container" key={paramId}>
                                <div className="graph-title" ref={el => graphTitleRefs.current[paramId] = el}>
                                    {paramTitle} : --
                                </div>
                                <Line
                                    ref={(el) => { graphRefs.current[paramId] = el; }}
                                    className="line-graph-vital"
                                    data={{
                                        datasets: [
                                            {
                                                label: paramTitle,
                                                data: paramData,
                                                borderWidth: 2,
                                                borderColor: "#FFFFFF",
                                                fill: false,
                                                tension: 0,
                                                pointRadius: 0,
                                                pointHoverRadius: 0,
                                                pointHitRadius: 0,
                                                spanGaps: false,


                                            },
                                        ],
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        animation: {
                                            onComplete: () => {
                                                updateGraphBounds();
                                                // setDisableCursor(false)

                                            }
                                        },

                                        onResize: () => {
                                            updateGraphBounds();
                                        },
                                        plugins: {
                                            legend: { display: false },
                                            title: {
                                                display: true,
                                                // text: paramTitle,
                                                align: "start",
                                                color: "#FFFFFF",
                                                font: { size: 16, weight: 600 },
                                                padding: { bottom: 18 },
                                            },
                                            tooltip: {
                                                // callbacks: {
                                                //     title: function (tooltipItems) {
                                                //         const ts = tooltipItems[0].parsed.x;
                                                //         return moment.utc(ts)
                                                //             .utcOffset(330)
                                                //             .format("HH:mm:ss.SSS");
                                                //     },
                                                //     label: function (tooltipItem) {
                                                //         return `Value: ${tooltipItem.parsed.y}`;
                                                //     }
                                                // }
                                                enabled: false,
                                            }
                                        },
                                        scales: {
                                            x: {
                                                type: "time",
                                                min: props?.PatientHistoryTimeData?.startDateTime,
                                                max: props?.PatientHistoryTimeData?.endDateTime,
                                                adapters: {
                                                    date: { zone: "Asia/Kolkata" }
                                                },
                                                time: {
                                                    displayFormats: {
                                                        second: "HH:mm:ss",
                                                    },
                                                },
                                                ticks: { maxRotation: 0, autoSkip: true, maxTicksLimit: 6 },
                                                grid: { borderColor: "#4D4D4D" },
                                            },
                                            y: {
                                                min: 0,
                                                max: yAxisMax,
                                                position: "left",
                                                ticks: {
                                                    stepSize: stepSize,
                                                    callback: value => Number(value).toFixed(2),
                                                },
                                                afterFit(scale) {
                                                    scale.width = 60;
                                                },
                                                grid: {
                                                    borderColor: "#4D4D4D",
                                                    color: (ctx) =>
                                                        ctx.index % 4 === 0 ? "#808080" : "transparent",
                                                    borderDash: [4, 4],
                                                },
                                            }
                                        },
                                    }}
                                    style={{ height: "10vw" }}
                                />
                            </div>
                        );
                    })}

                    {hasMore &&
                        <div className="spinner-container">
                            <div className="spinner"></div>
                        </div>
                    }

                    <div ref={bottomRef} style={{ height: "50px" }} />
                </div>

            </div>


        </>
    );
}

const mapStateToProps = (state, ownProps) => {

    let ventilatorPatientHistoryTimeData = state.volatileDataReducer?.ventilatorPatientHistoryTimeData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryTimeData in mapProps in V730iParameterGraph", ventilatorPatientHistoryTimeData)

    let ventilatorPatientHistoryGraphApiData = state.volatileDataReducer?.ventilatorPatientHistoryGraphApiData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryGraphApiData in mapProps in V730iParameterGraph", ventilatorPatientHistoryGraphApiData)

    let ventilatorPatientHistoryCursorData = state.volatileDataReducer?.ventilatorPatientHistoryCursorData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryCursorData in mapProps in V730iParameterGraph", ventilatorPatientHistoryCursorData)

    // let ventilatorPatientHistoryCurrentCursorTime = state.volatileDataReducer?.ventilatorPatientHistoryCurrentCursorTime?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryCurrentCursorTime in mapProps in V730iParameterGraph", ventilatorPatientHistoryCurrentCursorTime)

    return {
        PatientHistoryTimeData: ventilatorPatientHistoryTimeData,
        PatientHistoryGraphData: ventilatorPatientHistoryGraphApiData,
        PatientHistoryCursorData: ventilatorPatientHistoryCursorData,
        // PatientHistoryCurrentCursorTime: ventilatorPatientHistoryCurrentCursorTime

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ventilatorPatientHistoryGraphApiData: (payload) => dispatch(ventilatorPatientHistoryGraphApiData(payload)),
        ventilatorPatientHistoryCursorData: (payload) => dispatch(ventilatorPatientHistoryCursorData(payload)),
        ventilatorPatientHistoryCurrentCursorTime: (payload) => dispatch(ventilatorPatientHistoryCurrentCursorTime(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(V730iParameterGraph);
















